import { RouteRecordRaw } from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import DevTools from '@/views/dev-tools/DevTools.vue'
import Inventory from '@/views/inventory/Inventory.vue'
import Sales from '@/views/sales/Sales.vue'
import Customers from '@/views/customers/Customers.vue'
import Pets from '@/views/pets/Pets.vue'
import Pet from '@/views/pets/Pet.vue'
import PetView from '@/views/pets/PetView.vue'
import NewPet from '@/views/pets/NewPet.vue'
import HumanResources from '@/views/hr/HumanResources.vue'
import Roles from '@/views/hr/roles/Roles.vue'
import Role from '@/views/hr/roles/Role.vue'
import NewRole from '@/views/hr/roles/NewRole.vue'
import Accounting from '@/views/accounting/Accounting.vue'
import Settings from '@/views/settings/Settings.vue'
import License from '@/views/license/License.vue'
import Vendors from '@/views/companies/vendors/Vendors.vue'
import AccountingVendors from '@/views/accounting/vendors/Vendors.vue'
import Examination from '@/views/examinations/Examinations.vue'
import ZeissCards from '@/views/examinations/zeissCards/ZeissCards.vue'
import NewZeissCard from '@/views/examinations/zeissCards/NewZeissCard.vue'
import ZeissCardSettings from '@/views/examinations/zeissCards/ZeissCardSettings.vue'
import ZeissCardPrint from '@/views/examinations/zeissCards/ZeissCardPrint.vue'
import OpenRegister from '@/views/sales/registers/OpenRegister.vue'
import NewCheckout from '@/views/sales/NewCheckout.vue'
import CheckoutContainer from '@/views/sales/CheckoutContainer.vue'
import Orders from '@/views/sales/Orders.vue'
import Transactions from '@/views/sales/Transactions.vue'
import DiscountCodes from '@/views/sales/DiscountCodes.vue'
import AccountingTransactions from '@/views/accounting/transactions/Transactions.vue'
import Order from '@/views/sales/Order.vue'
import SaleReceipt from '@/views/sales/new-receipt/SaleReceipt.vue'
import Quotes from '@/views/sales/Quotes.vue'
import NewQuote from '@/views/sales/NewQuote.vue'
import QuoteView from '@/views/sales/QuoteView.vue'
import QuoteReceipt from '@/views/sales/new-receipt/QuoteReceipt.vue'
import ReturnOrders from '@/views/sales/ReturnOrders.vue'
import ReturnOrder from '@/views/sales/ReturnOrder.vue'
import ReturnReceipt from '@/views/sales/new-receipt/ReturnReceipt.vue'
import OrderEdit from '@/views/sales/OrderEdit.vue'
import OrderPayment from '@/views/sales/OrderPayment.vue'
import OrderFulfill from '@/views/sales/OrderFulfill.vue'
import CloseRegister from '@/views/sales/registers/CloseRegister.vue'
import Items from '@/views/inventory/items/Items.vue'
import SimpleItem from '@/views/inventory/items/SimpleItem.vue'
import ItemView from '@/views/inventory/items/ItemView.vue'
import NewSimpleItem from '@/views/inventory/items/NewSimpleItem.vue'
import CustomPrices from '@/views/inventory/customPrices/CustomPrices.vue'
import CustomPrice from '@/views/inventory/customPrices/CustomPrice.vue'
import NewCustomPrice from '@/views/inventory/customPrices/NewCustomPrice.vue'
import Brands from '@/views/inventory/brands/Brands.vue'
import Brand from '@/views/inventory/brands/Brand.vue'
import NewBrand from '@/views/inventory/brands/NewBrand.vue'
import Categories from '@/views/inventory/categories/Categories.vue'
import Category from '@/views/inventory/categories/Category.vue'
import NewCategory from '@/views/inventory/categories/NewCategory.vue'
import Tags from '@/views/inventory/tags/Tags.vue'
import Tag from '@/views/inventory/tags/Tag.vue'
import NewTag from '@/views/inventory/tags/NewTag.vue'
import InventoryReceivings from '@/views/inventory/inventoryReceivings/InventoryReceivings.vue'
import InventoryReceiving from '@/views/inventory/inventoryReceivings/InventoryReceiving.vue'
import NewInventoryReceiving from '@/views/inventory/inventoryReceivings/NewInventoryReceiving.vue'
import InventoryReceivingReceipt from '@/views/inventory/receiving/InventoryReceivingReceipt.vue'
import InventoryAdjustments from '@/views/inventory/inventoryAdjustments/InventoryAdjustments.vue'
import InventoryAdjustment from '@/views/inventory/inventoryAdjustments/InventoryAdjustment.vue'
import NewInventoryAdjustment from '@/views/inventory/inventoryAdjustments/NewInventoryAdjustment.vue'
import BulkInventoryAdjustment from '@/views/inventory/inventoryAdjustments/BulkInventoryAdjustment.vue'
import MissingSerials from '@/views/inventory/missingSerials/MissingSerials.vue'
import AddMissingSerials from '@/views/inventory/missingSerials/AddMissingSerials.vue'
import InventoryTransfers from '@/views/inventory/inventoryTransfers/InventoryTransfers.vue'
import InventoryTransfer from '@/views/inventory/inventoryTransfers/InventoryTransfer.vue'
import NewInventoryTransfer from '@/views/inventory/inventoryTransfers/NewInventoryTransfer.vue'
import ReceiveInventoryTransfer from '@/views/inventory/inventoryTransfers/ReceiveInventoryTransfer.vue'
import PrintBarcode from '@/views/inventory/barcode/PrintBarcode.vue'
import Customer from '@/views/customers/Customer.vue'
import CustomerView from '@/views/customers/CustomerView.vue'
import NewCustomer from '@/views/customers/NewCustomer.vue'
import NewExamination from '@/views/examinations/NewExamination.vue'
import ExaminationView from '@/views/examinations/ExaminationView.vue'
import CustomerAccountStatement from '@/views/customers/CustomerAccountStatement.vue'
import VendorAccountStatement from '@/views/companies/vendors/VendorAccountStatement.vue'
import ExaminationReceipt from '@/views/examinations/ExaminationReceipt.vue'
import ExaminationReceiptV2 from '@/views/examinations/ExaminationReceiptV2.vue'
import ExaminationIDPrint from '@/views/examinations/ExaminationIDPrint.vue'
import ExaminationIDPrintV2 from '@/views/examinations/ExaminationIDPrintV2.vue'
import Notes from '@/views/customers/notes/Notes.vue'
import NewNote from '@/views/customers/notes/NewNote.vue'
import NoteView from '@/views/customers/notes/NoteView.vue'
import NoteEdit from '@/views/customers/notes/NoteEdit.vue'
import Vendor from '@/views/companies/vendors/Vendor.vue'
import VendorView from '@/views/companies/vendors/VendorView.vue'
import NewVendor from '@/views/companies/vendors/NewVendor.vue'
import Employees from '@/views/hr/employees/Employees.vue'
import Employee from '@/views/hr/employees/Employee.vue'
import NewEmployee from '@/views/hr/employees/NewEmployee.vue'
import ViewEmployeeSchedule from '@/views/hr/employeeSchedule/ViewEmployeeSchedule.vue'
import NewEmployeeSchedule from '@/views/hr/employeeSchedule/NewEmployeeSchedule.vue'
import SafesBanks from '@/views/accounting/safesBanks/SafesBanks.vue'
import NewSafe from '@/views/accounting/safesBanks/NewSafe.vue'
import NewBank from '@/views/accounting/safesBanks/NewBank.vue'
import Accounts from '@/views/accounting/accounts/Accounts.vue'
import Account from '@/views/accounting/accounts/Account.vue'
import AccountView from '@/views/accounting/accounts/AccountView.vue'
import AccountLog from '@/views/accounting/accounts/AccountLog.vue'
import NewAccount from '@/views/accounting/accounts/NewAccount.vue'
import NewAccountTemplate from '@/views/accounting/accounts/NewAccountTemplate.vue'
import Transaction from '@/views/accounting/transactions/Transaction.vue'
import NewTransaction from '@/views/accounting/transactions/NewTransaction.vue'
import CustomerInvoicesByCustomer from '@/views/accounting/customers/CustomerInvoicesByCustomer.vue'
import Registers from '@/views/accounting/registers/Registers.vue'
import Register from '@/views/accounting/registers/Register.vue'
import Hr from '@/views/accounting/hr/Hr.vue'
import NewBill from '@/views/accounting/vendors/NewBill.vue'
import VendorBillPayment from '@/views/accounting/vendors/VendorBillPayment.vue'
import VendorBillReceipt from '@/views/accounting/vendors/VendorBillReceipt.vue'
import RegisterTransaction from '@/views/accounting/registers/RegisterTransaction.vue'
import NewPay from '@/views/accounting/hr/NewPay.vue'
import NewExpense from '@/views/accounting/company/NewExpense.vue'
import Reports from '@/views/reports/Reports.vue'
import SalesByCategory from '@/views/reports/sales/SalesByCategory.vue'
import TopSoldItems from '@/views/reports/v2/sales/TopSoldItems.vue'
import SalesByItem from '@/views/reports/sales/SalesByItem.vue'
import LeastSoldItems from '@/views/reports/sales/LeastSoldItems.vue'
import InventoryValue from '@/views/reports/inventory/InventoryValue.vue'
import InventoryValueDetails from '@/views/reports/inventory/InventoryValueDetails.vue'
import NewRegisterClosing from '@/views/reports/sales/RegisterClosing/NewRegisterClosing.vue'
import SalesComparison from '@/views/reports/sales/SalesComparison.vue'
import VendorsBalances from '@/views/reports/vendors/VendorsBalances.vue'
import CustomersBalances from '@/views/reports/accounting/CustomersBalances.vue'
import SalesHeatmap from '@/views/reports/sales/SalesHeatmap.vue'
import QuantityReport from '@/views/reports/inventory/QuantityReport.vue'
import AllItemsReport from '@/views/reports/inventory/AllItemsReport.vue'
import ProfitAndLoss from '@/views/reports/accounting/ProfitAndLoss.vue'
import NewReturnOrder from '@/views/sales/NewReturnOrder.vue'
import TransactionReceipt from '@/views/sales/new-receipt/TransactionReceipt.vue'
import RegisterClosingReport from '@/views/sales/registers/RegisterClosingReport.vue'
import EmployeesTopSalary from '@/views/reports/v2/hr/EmployeesTopSalary.vue'
import InventoryQuickFacts from '@/views/reports/v2/inventory/InventoryQuickFacts.vue'
import NegativeStockInventory from '@/views/reports/v2/inventory/NegativeStockInventory.vue'
import LowStockInventory from '@/views/reports/v2/inventory/LowStockInventory.vue'
import CustomerInvoices from '@/views/accounting/customers/CustomerInvoices.vue'
import Expenses from '@/views/accounting/company/Expenses.vue'
import WeeklySales from '@/views/reports/v2/sales/WeeklySales.vue'
import MonthlySales from '@/views/reports/v2/sales/MonthlySales.vue'
import TotalReturns from '@/views/reports/v2/sales/TotalReturns.vue'
import SalesDetails from '@/views/reports/v2/sales/SalesDetails.vue'
import SalesSummary from '@/views/reports/v2/sales/SalesSummary.vue'
import TopReps from '@/views/reports/v2/sales/TopReps.vue'
import TopSalesReps from '@/views/reports/v2/sales/TopSalesReps.vue'
import VendorBillView from '@/views/accounting/vendors/VendorBillView.vue'
import EmployeesAttendance from '@/views/reports/v2/hr/EmployeesAttendance.vue'
import EmployeessCommissions from '@/views/reports/v2/hr/EmployeessCommissions.vue'
import MoneyCollectorCommissionReport from '@/views/reports/v2/hr/MoneyCollectorCommissionReport.vue'
import CustomersOutstandingBalances from '@/views/reports/v2/customers/CustomersOutstandingBalances.vue'
import FrequentCustomers from '@/views/reports/v2/customers/FrequentCustomers.vue'
import TopCustomers from '@/views/reports/v2/customers/TopCustomers.vue'
import TopVendors from '@/views/reports/v2/vendors/TopVendors.vue'
import VendorsOutstandingBalances from '@/views/reports/v2/vendors/VendorsOutstandingBalances.vue'
import FrequentVendors from '@/views/reports/v2/vendors/FrequentVendors.vue'
import RegisterClosingReportV2 from '@/views/reports/v2/accounting/RegisterClosingReport.vue'
import RegisterClosingSummary from '@/views/reports/v2/accounting/RegisterClosingSummary.vue'
import CashAssetsReport from '@/views/reports/v2/accounting/CashAssetsReport.vue'
import ExpensesReport from '@/views/reports/v2/accounting/ExpensesReport.vue'
import CustomersBirthdays from '@/views/reports/v2/customers/CustomersBirthdays.vue'
import Attributes from '@/views/inventory/attributes/Attributes.vue'
import Attribute from '@/views/inventory/attributes/Attribute.vue'
import NewAttribute from '@/views/inventory/attributes/NewAttribute.vue'
import ItemReport from '@/views/reports/v2/inventory/ItemReport.vue'
import BatchTrackerReport from '@/views/reports/v2/inventory/BatchTrackerReport.vue'
import InventoryExpirableItemsInsight from '@/views/reports/v2/inventory/InventoryExpirableItemsInsight.vue'
import Commissions from "@/views/hr/commissions/Commissions.vue";
import NewCommission from "@/views/hr/commissions/NewCommission.vue";
import Commission from "@/views/hr/commissions/Commission.vue";
import Tasks from "@/views/hr/tasks/Tasks.vue";
import MoneyCollectorCommissions from "@/views/hr/money-collector-commissions/MoneyCollectorCommissions.vue";
import NewMoneyCollectorCommission from "@/views/hr/money-collector-commissions/NewMoneyCollectorCommission.vue";
import MoneyCollectorCommission from "@/views/hr/money-collector-commissions/MoneyCollectorCommission.vue";
import Packs from "@/views/inventory/packs/Packs.vue";
import Pack from '@/views/inventory/packs/Pack.vue'
import NewPack from '@/views/inventory/packs/NewPack.vue'
import Backups from "@/views/backup/Backups.vue";
import NumberOfExaminations
  from "@/views/reports/v2/examinations/NumberOfExaminations.vue";
import PurchaseOrder from "@/views/inventory/purchaseOrder/PurchaseOrder.vue";
import PurchaseOrders from "@/views/inventory/purchaseOrder/PurchaseOrders.vue";
import NewPurchaseOrders
  from "@/views/inventory/purchaseOrder/NewPurchaseOrders.vue";
import PurchaseOrderReceipt
  from "@/views/inventory/purchaseOrder/PurchaseOrderReceipt.vue";
import NewPurchaseOrderInventoryReceiving
  from "@/views/inventory/purchaseOrder/NewPurchaseOrderInventoryReceiving.vue";
import InventoryTransactions
  from "@/views/inventory/inventoryTransactions/InventoryTransactions.vue";
import TransactionChildren from "@/views/sales/TransactionChildren.vue";
import Companies from "@/views/companies/Companies.vue";
import Deliveries from "@/views/companies/deliveries/Deliveries.vue";
import Delivery from "@/views/companies/deliveries/Delivery.vue";
import DeliveryView from "@/views/companies/deliveries/DeliveryView.vue";
import NewDelivery from "@/views/companies/deliveries/NewDelivery.vue";
import Insurances from "@/views/companies/insurances/Insurances.vue";
import Insurance from "@/views/companies/insurances/Insurance.vue";
import InsuranceView from "@/views/companies/insurances/InsuranceView.vue";
import NewInsurance from "@/views/companies/insurances/NewInsurance.vue";
import DeliveryAccountStatement
  from "@/views/companies/deliveries/DeliveryAccountStatement.vue";
import InsuranceAccountStatement
  from "@/views/companies/insurances/InsuranceAccountStatement.vue";
import CustomersQueue from "@/views/customers/CustomersQueue.vue";
import CustomersQueueMonitor from "@/views/customers/CustomersQueueMonitor.vue";
import GlassesJobs from "@/views/customers/GlassesJobs.vue";
import GlassesJobsMonitor from "@/views/customers/GlassesJobsMonitor.vue";
import Appointments from "@/views/appointments/Appointments.vue";
import AppointmentView from "@/views/appointments/AppointmentView.vue";
import NewAppointment from "@/views/appointments/NewAppointment.vue";
import VetServices from "@/views/vetServices/VetServices.vue";
import VetService from "@/views/vetServices/VetService.vue";
import NewVetService from "@/views/vetServices/NewVetService.vue";
import FormsOfPaymentsReport
  from "@/views/reports/v2/accounting/FormsOfPaymentsReport.vue";
import ImportItems from "@/views/inventory/items/ImportItems.vue";
import ProfitByItem from '@/views/reports/v2/accounting/ProfitByItem.vue'
import OrdersStatementReport from '@/views/reports/v2/sales/OrdersStatementReport.vue'
import SalesByVendor from '@/views/reports/v2/sales/SalesByVendor.vue'
import ItemBatches from '@/views/inventory/items/ItemBatches.vue'
import VetServicesByPet from '@/views/reports/v2/pets/VetServicesByPet.vue'
import VetAllServices from '@/views/reports/v2/pets/VetAllServices.vue'
import NotificationsPage from '@/views/notifications/Notifications.vue'
import { useSettingsStore } from '@/stores/settingsStore'

// Picks between the V1 and V2 examination printouts, mirroring how
// use_new_version_of_examination_creator picks between the two creator forms.
// Read at navigation time rather than module load, so it reflects the settings
// fetched after login. Defaults to the V2 designs when the setting is absent.
function useNewExaminationPrints(): boolean {
  return useSettingsStore().getValue('use_new_version_of_examination_prints') !== 'false'
}

export enum Route {
  HOME = '/',
  NOTIFICATIONS = '/notifications',

  LOGIN = '/login',

  SALES = '/sales',
  SALES_NEW_SALE = '/sales/new-sale',
  SALES_ORDERS = '/sales/orders',
  SALES_ORDERS_ORDER = '/sales/orders/order/:id',
  SALES_ORDERS_ORDER_RECEIPT = '/sales/orders/order/:id/receipt',
  SALES_ORDERS_RETURN_ORDERS = '/sales/orders/return-orders',
  SALES_ORDERS_NEW_RETURN_ORDER = '/sales/orders/new-return-order',
  SALES_ORDERS_RETURN_ORDER = '/sales/orders/return-orders/:orderID',
  SALES_ORDERS_RETURN_ORDER_RECEIPT = '/sales/orders/return-orders/:id/receipt/:orderChangeID',
  SALES_ORDERS_ORDER_EDIT = '/sales/orders/order/:id/edit',
  SALES_ORDERS_ORDER_FULFILL = '/sales/orders/order/:id/fulfill',
  SALES_ORDERS_ORDER_PAYMENT = '/sales/orders/order/:id/order-payment',
  SALES_ORDERS_ORDER_PAYMENT_RECEIPT = '/sales/orders/order-payment/:id/receipt',
  SALES_REGISTERS_OPEN_REGISTER = '/sales/registers/open-register',
  SALES_REGISTERS_CLOSE_REGISTER = '/sales/registers/close-register',
  SALES_REGISTERS_CLOSE_REGISTER_REPORT = '/sales/registers/close-register/report/:id',
  SALES_QUOTES = '/sales/quotes',
  SALES_QUOTES_NEW = '/sales/quotes/new',
  SALES_QUOTES_QUOTE = '/sales/quotes/quote/:id',
  SALES_QUOTES_RECEIPT = '/sales/quotes/quote/:id/receipt',
  SALES_DISCOUNT_CODES = '/sales/discount-codes',
  SALES_TRANSACTIONS = '/sales/transactions',
  SALES_CHILD_TRANSACTIONS = '/sales/transactions/:transactionID/children',
  SALES_TRANSACTIONS_RECEIPT = '/sales/transactions/:transactionID/receipt',

  INVENTORY = '/inventory',
  INVENTORY_ITEMS = '/inventory/items',
  INVENTORY_ITEMS_ITEM_BATCHES = '/inventory/item-batches',
  INVENTORY_ITEMS_SIMPLE_ITEM = '/inventory/items/simple-item/:id',
  INVENTORY_ITEMS_ITEM_VIEW = '/inventory/items/item/view/:id',
  INVENTORY_ITEMS_NEW_SIMPLE_ITEM = '/inventory/items/new-simple-item',
  INVENTORY_ITEM_BRANDS = '/inventory/item-brands',
  INVENTORY_ITEM_BRANDS_BRAND = '/inventory/item-brands/brand/:id',
  INVENTORY_ITEM_BRANDS_NEW_BRAND = '/inventory/item-brands/new-brand',
  INVENTORY_ITEM_CUSTOM_PRICE_TYPES = '/inventory/custom-price-types',
  INVENTORY_ITEM_CUSTOM_PRICE_TYPE = '/inventory/custom-price-types/type/:id',
  INVENTORY_ITEM_NEW_CUSTOM_PRICE_TYPE = '/inventory/custom-price-types/new-type',
  INVENTORY_ATTRIBUTES = '/inventory/attributes',
  INVENTORY_ATTRIBUTES_ATTRIBUTE = '/inventory/attributes/:id',
  INVENTORY_ITEM_NEW_ATTRIBUTE = '/inventory/attributes/new-attribute',
  INVENTORY_ITEM_CATEGORIES = '/inventory/item-categories',
  INVENTORY_ITEM_CATEGORIES_CATEGORY = '/inventory/item-categories/category/:id',
  INVENTORY_ITEM_CATEGORIES_NEW_CATEGORY = '/inventory/item-categories/new-category',
  INVENTORY_ITEM_TAGS = '/inventory/item-tags',
  INVENTORY_ITEM_TAGS_TAG = '/inventory/item-tags/tag/:id',
  INVENTORY_ITEM_TAGS_NEW_TAG = '/inventory/item-tags/new-tag',
  INVENTORY_INVENTORY_RECEIVINGS = '/inventory/inventory-receivings',
  INVENTORY_INVENTORY_RECEIVINGS_INVENTORY_RECEIVING = '/inventory/inventory-receivings/inventory-receiving/:id',
  INVENTORY_INVENTORY_RECEIVINGS_NEW_INVENTORY_RECEIVING = '/inventory/inventory-receivings/new-inventory-receiving',
  INVENTORY_INVENTORY_RECEIVINGS_RECEIPT = '/inventory/inventory-receivings/:id/receipt',
  INVENTORY_INVENTORY_ADJUSTMENTS = '/inventory/inventory-adjustments',
  INVENTORY_INVENTORY_ADJUSTMENTS_INVENTORY_ADJUSTMENT = '/inventory/inventory-adjustments/inventory-adjustment/:id',
  INVENTORY_INVENTORY_ADJUSTMENTS_NEW_INVENTORY_ADJUSTMENT = '/inventory/inventory-adjustments/new-inventory-adjustment',
  INVENTORY_INVENTORY_ADJUSTMENTS_BULK_INVENTORY_ADJUSTMENT = '/inventory/inventory-adjustments/bulk-inventory-adjustment',
  INVENTORY_MISSING_SERIALS = '/inventory/missing-serials',
  INVENTORY_ADD_MISSING_SERIALS = '/inventory/add-missing-serials/:id',
  INVENTORY_INVENTORY_TRANSFERS = '/inventory/inventory-transfers',
  INVENTORY_INVENTORY_TRANSFERS_INVENTORY_TRANSFER = '/inventory/inventory-transfers/inventory-transfer/:id',
  INVENTORY_INVENTORY_TRANSFERS_NEW_INVENTORY_TRANSFER = '/inventory/inventory-transfers/new-inventory-transfer',
  INVENTORY_INVENTORY_TRANSFERS_RECEIVE_INVENTORY_TRANSFER = '/inventory/inventory-transfers/receive-inventory-transfer',
  INVENTORY_PACKS = '/inventory/packs',
  INVENTORY_PACK = '/inventory/packs/type/:id',
  INVENTORY_NEW_PACK = '/inventory/packs/new-pack',
  INVENTORY_PURCHASE_ORDERS= '/inventory/purchase-orders',
  INVENTORY_PURCHASE_ORDER= '/inventory/purchase-orders/order/:id',
  INVENTORY_NEW_PURCHASE_ORDER= '/inventory/new-purchase-order',
  INVENTORY_PURCHASE_ORDERS_PURCHASE_ORDER_RECEIPT = '/inventory/purchase-orders/order/:id/receipt',
  INVENTORY_PURCHASE_ORDERS_NEW_INVENTORY_RECEIVING = '/inventory/purchase-orders/order/:id/new-inventory-receiving',
  INVENTORY_TRANSACTIONS = '/inventory/transactions',

  INVENTORY_PRINT_BARCODE = '/inventory/print-barcode',
  INVENTORY_IMPORT_ITEMS = '/inventory/import-items',

  CUSTOMERS = '/customers',
  CUSTOMERS_CUSTOMER = '/customers/customer/:id',
  CUSTOMERS_CUSTOMER_VIEW = '/customers/customer/view/:id',
  CUSTOMERS_NEW_CUSTOMER = '/customers/new-customer',
  CUSTOMERS_NEW_EXAMINATION = '/customers/:customer_id/new-examination',
  CUSTOMERS_ACCOUNT_STATEMENT = '/customers/:customer_id/account-statement',
  CUSTOMERS_BIRTHDAYS = '/customers/birthdays',
  CUSTOMERS_QUEUE = '/customers/queue',
  CUSTOMERS_QUEUE_MONITOR = '/customers/queue/monitor',
  CUSTOMERS_GLASSES_JOBS = '/customers/glasses-jobs',
  CUSTOMERS_GLASSES_JOBS_MONITOR = '/customers/glasses-jobs/monitor',

  CUSTOMERS_NOTES = '/customers/notes',
  CUSTOMERS_NOTES_NEW = '/customers/notes/new',
  CUSTOMERS_NOTES_VIEW = '/customers/notes/view/:id',
  CUSTOMERS_NOTES_EDIT = '/customers/notes/edit/:id',

  PETS = '/pets',
  PETS_PET_VIEW = '/pets/pet/:id/view',
  PETS_PET = '/pets/pet/:id',
  PETS_NEW_PET = '/pets/new-pet',

  VET_SERVICES = '/vet-services',
  VET_SERVICES_SERVICE = '/vet-services/service/:id',
  VET_SERVICES_NEW = '/vet-services/new',

  EXAMINATIONS = '/examinations',
  EXAMINATIONS_EXAMINATION_VIEW = '/examinations/examination/view/:examination_id',
  EXAMINATIONS_NEW_EXAMINATION = '/examinations/new-examination',
  EXAMINATIONS_ZEISS_CARDS = '/examinations/zeiss-cards',
  EXAMINATIONS_ZEISS_CARDS_SETTINGS = '/examinations/zeiss-cards/settings',
  EXAMINATIONS_ZEISS_CARDS_NEW_CARD = '/examinations/zeiss-cards/new-card',
  EXAMINATIONS_ZEISS_CARDS_CARD_PRINT = '/examinations/zeiss-cards/:card_id/print',
  EXAMINATIONS_ZEISS_CARDS_CARD_EDIT = '/examinations/zeiss-cards/:card_id/edit',
  EXAMINATIONS_EXAMINATION_RECEIPT = '/examinations/examination/:examination_id/receipt',
  EXAMINATIONS_EXAMINATION_ID_PRINT = '/examinations/examination/:examination_id/id-print',

  APPOINTMENTS = '/appointments',
  APPOINTMENTS_APPOINTMENT_VIEW = '/appointments/appointment/view/:appointment_id',
  APPOINTMENTS_NEW_APPOINTMENT = '/appointments/new-appointment',

  COMPANIES = '/companies',
  DELIVERIES = '/companies/deliveries',
  DELIVERIES_DELIVERY = '/companies/deliveries/delivery/:id',
  DELIVERIES_DELIVERY_VIEW = '/companies/deliveries/delivery/view:id',
  DELIVERIES_NEW_DELIVERY = '/companies/deliveries/new-delivery',
  DELIVERIES_ACCOUNT_STATEMENT = '/companies/deliveries/:delivery_id/account-statement',

  INSURANCES = '/companies/insurances',
  INSURANCES_INSURANCE = '/companies/insurances/insurance/:id',
  INSURANCES_INSURANCE_VIEW = '/companies/insurances/insurance/view:id',
  INSURANCES_NEW_INSURANCE = '/companies/insurances/new-insurance',
  INSURANCES_ACCOUNT_STATEMENT = '/companies/insurances/:insurance_id/account-statement',

  VENDORS = '/companies/vendors',
  VENDORS_VENDOR = '/companies/vendors/vendor/:id',
  VENDORS_VENDOR_VIEW = '/companies/vendors/vendor/view:id',
  VENDORS_NEW_VENDOR = '/companies/vendors/new-vendor',
  VENDORS_ACCOUNT_STATEMENT = '/companies/vendors/:vendor_id/account-statement',

  HR = '/hr',
  HR_ROLES = '/hr/roles',
  HR_ROLES_ROLE = '/hr/roles/role/:id',
  HR_ROLES_NEW_ROLE = '/hr/roles/new-role',
  HR_EMPLOYEES = '/hr/employees',
  HR_EMPLOYEES_EMPLOYEE = '/hr/employees/employee/:id',
  HR_EMPLOYEES_NEW_EMPLOYEE = '/hr/employees/new-employee',
  HR_EMPLOYEE_SCHEDULE = '/hr/employee-schedules',
  HR_EMPLOYEE_SCHEDULES_NEW_EMPLOYEE_SCHEDULE = '/hr/employee-schedules/new-employee-schedule',
  HR_COMMISSIONS = '/hr/commissions',
  HR_COMMISSIONS_COMMISSION = '/hr/commissions/commission/:id',
  HR_COMMISSIONS_NEW_COMMISSION = '/hr/commissions/new-commission',
  HR_MONEY_COLLECTOR_COMMISSIONS = '/hr/money-collector-commissions',
  HR_MONEY_COLLECTOR_COMMISSIONS_EDIT = '/hr/money-collector-commissions/:id',
  HR_MONEY_COLLECTOR_COMMISSIONS_NEW = '/hr/money-collector-commissions/new',
  HR_TASKS = '/hr/tasks',

  ACCOUNTING = '/accounting',
  ACCOUNTING_ACCOUNTS = '/accounting/accounts',
  ACCOUNTING_ACCOUNTS_VIEW = '/accounting/accounts/view/:id',
  ACCOUNTING_ACCOUNTS_ACCOUNT = '/accounting/accounts/account/:id',
  ACCOUNTING_ACCOUNTS_NEW_ACCOUNT = '/accounting/accounts/new-account',
  ACCOUNTING_ACCOUNTS_NEW_ACCOUNT_TEMPLATE = '/accounting/accounts/new-account-template',
  ACCOUNTING_ACCOUNTS_LOG = '/accounting/accounts/log/:id',
  ACCOUNTING_TRANSACTIONS = '/accounting/transactions',
  ACCOUNTING_TRANSACTIONS_TRANSACTION = '/accounting/transactions/transaction/:id',
  ACCOUNTING_TRANSACTIONS_NEW_TRANSACTION = '/accounting/transactions/new-transaction',
  ACCOUNTING_CUSTOMERS = '/accounting/customers',
  ACCOUNTING_CUSTOMER_INVOICES = '/accounting/customers/customer-invoices/:id',
  ACCOUNTING_VENDORS = '/accounting/vendors',
  ACCOUNTING_VENDORS_NEW_BILL = '/accounting/vendors/new-bill',
  ACCOUNTING_VENDORS_BILL_VIEW = '/accounting/vendors/:id',
  ACCOUNTING_VENDORS_BILL_PAYMENT = '/accounting/vendors/:id/vendor-bill-payment',
  ACCOUNTING_VENDORS_BILL_RECEIPT = '/accounting/vendors/:id/receipt',
  ACCOUNTING_SAFES_BANKS = '/accounting/safes-banks',
  ACCOUNTING_SAFES_NEW = '/accounting/safes-banks/new-safe',
  ACCOUNTING_BANKS_NEW = '/accounting/safes-banks/new-bank',
  ACCOUNTING_REGISTERS = '/accounting/registers',
  ACCOUNTING_REGISTERS_REGISTER = '/accounting/registers/register/:id',
  ACCOUNTING_REGISTERS_REGISTER_TRANSACTION = '/accounting/registers/transactions/register/:id',
  ACCOUNTING_HR = '/accounting/hr',
  ACCOUNTING_HR_NEW_PAY = '/accounting/hr/new-pay',
  ACCOUNTING_COMPANY = '/accounting/company',
  ACCOUNTING_COMPANY_NEW_EXPENSE = '/accounting/company/new-expense',

  REPORTS = '/reports',
  REPORTS_SALES_SALES_BY_CATEGORY = '/reports/sales/sales-by-category',
  REPORTS_SALES_SALES_BY_ITEM = '/reports/sales/sales-by-item',
  REPORTS_SALES_TOP_SOLD_ITEMS = '/reports/sales/top-sold-items',
  REPORTS_SALES_TOTAL_SALES = '/reports/sales/total-sales',
  REPORTS_SALES_TOTAL_RETURNS = '/reports/sales/total-returns',
  REPORTS_SALES_WEEKLY_SALES = '/reports/sales/weekly-sales',
  REPORTS_SALES_MONTHLY_SALES = '/reports/sales/monthly-sales',
  REPORTS_SALES_TOP_REPS = '/reports/sales/top-reps',
  REPORTS_SALES_SALES_REPS = '/reports/sales/top-sales-reps',
  REPORTS_SALES_ORDERS_STATEMENT = '/reports/sales/orders-statement',
  REPORTS_SALES_SALES_BY_VENDOR = '/reports/sales/sales-by-vendor',
  REPORTS_SALES_LEAST_SOLD_ITEMS = '/reports/sales/least-sold-items',
  REPORTS_SALES_SALES_DETAILS = '/reports/sales/sales-details',
  REPORTS_SALES_SALES_SUMMARY = '/reports/sales/sales-summary',
  REPORTS_SALES_SALES_NEW_REGISTER_CLOSING = '/reports/sales/new-register-closing',
  REPORTS_SALES_SALES_REGISTER_CLOSING_REPORT = '/reports/sales/register-closing-report',
  REPORTS_SALES_END_OF_DAY = '/reports/sales/end-of-day',
  REPORTS_SALES_SALES_COMPARISON = '/reports/sales/sales-comparison',
  REPORTS_SALES_SALES_HEATMAP = '/reports/sales/sales-heatmap',
  REPORTS_INVENTORY_QUANTITY = '/reports/inventory/quantity',
  REPORTS_INVENTORY_INVENTORY_VALUE = '/reports/inventory/inventory-value',
  REPORTS_INVENTORY_INVENTORY_VALUE_DETAILS = '/reports/inventory/inventory-value-details',
  REPORTS_VENDORS_VENDORS_BALANCES = '/reports/vendors/vendors-balances',

  REPORTS_ACCOUNTING_PROFIT_AND_LOSS = '/reports/accounting/profit-and-loss',
  REPORTS_ACCOUNTING_CUSTOMERS_BALANCES = '/reports/accounting/customers-balances',
  REPORTS_ACCOUNTING_REGISTER_CLOSING = '/reports/accounting/register-closing',
  REPORTS_ACCOUNTING_REGISTER_CLOSING_SUMMARY = '/reports/accounting/register-closing-summary',
  REPORTS_ACCOUNTING_CASH_ASSETS = '/reports/accounting/cash-assets',
  REPORTS_ACCOUNTING_EXPENSES = '/reports/accounting/expenses',
  REPORTS_ACCOUNTING_FORMS_OF_PAYMENTS = '/reports/accounting/forms-of-payments',
  REPORTS_ACCOUNTING_PROFIT_BY_ITEM = '/reports/accounting/profit-by-item',

  REPORTS_INVENTORY_ITEM = '/reports/inventory/item',
  REPORTS_INVENTORY_BATCH_TRACKER = '/reports/inventory/batch-tracker',
  REPORTS_INVENTORY_EXPIRABLE_ITEMS_INSIGHT = '/reports/inventory/expirable-items-insight',

  REPORTS_INVENTORY_QUICK_FACTS = '/reports/inventory/quick-facts',
  REPORTS_INVENTORY_LOW_STOCK = '/reports/inventory/low-stock-inventory',
  REPORTS_INVENTORY_NEGATIVE_STOCK = '/reports/inventory/negative-stock-inventory',
  REPORTS_INVENTORY_ALL_ITEMS = '/reports/inventory/all-items',
  REPORTS_HR_TOP_SALARIES = '/reports/hr/top-salaries',
  REPORTS_HR_EMPLOYEE_ATTENDANCE = '/reports/hr/employee-attendance',
  REPORTS_HR_EMPLOYEE_COMMISSION = '/reports/hr/employee-commissions',
  REPORTS_HR_MONEY_COLLECTOR_COMMISSION = '/reports/hr/money-collector-commissions',

  REPORTS_CUSTOMERS_OUTSTANDING_BALANCES = '/reports/customers/outstanding-balances',
  REPORTS_CUSTOMERS_FREQUENT_CUSTOMERS = '/reports/customers/frequent-customers',
  REPORTS_CUSTOMERS_TOP_CUSTOMERS = '/reports/customers/top-customers',

  REPORTS_VENDORS_TOP_VENDORS = '/reports/vendors/top-vendors',
  REPORTS_VENDORS_OUTSTANDING_BALANCES = '/reports/vendors/outstanding-balances',
  REPORTS_VENDORS_FREQUENT_VENDORS = '/reports/vendors/frequent-vendors',

  REPORTS_EXAMINATIONS_NUMBER_OF_EXAMINATIONS = '/reports/examinations/number-of-examinations',

  REPORTS_PETS_VET_SERVICES_BY_PET = '/reports/pets/vet-services-by-pet',
  REPORTS_PETS_VET_ALL_SERVICES = '/reports/pets/vet-all-services',

  SETTINGS = '/settings',
  LICENSE = '/license',
  BACKUPS = '/backups',
  DEV_TOOLS = '/dev-tools'
}

export const routes: Array<RouteRecordRaw> = [
  {
    path: Route.HOME,
    name: 'home',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: Route.LOGIN,
    name: 'login',
    component: Login,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.CUSTOMERS_QUEUE,
    name: 'customers-queue',
    component: CustomersQueue,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.CUSTOMERS_QUEUE_MONITOR,
    name: 'customers-queue-monitor',
    component: CustomersQueueMonitor,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: Route.CUSTOMERS_GLASSES_JOBS,
    name: 'customers-glasses-jobs',
    component: GlassesJobs,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.CUSTOMERS_GLASSES_JOBS_MONITOR,
    name: 'customers-glasses-jobs-monitor',
    component: GlassesJobsMonitor,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: Route.SALES,
    name: 'sales',
    component: Sales,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_NEW_SALE,
    name: 'new-sale',
    component: CheckoutContainer,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_ORDERS,
    name: 'orders',
    component: Orders,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_QUOTES,
    name: 'quotes',
    component: Quotes,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_QUOTES_NEW,
    name: 'new-quote',
    component: NewQuote,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_QUOTES_QUOTE,
    name: 'quote-view',
    component: QuoteView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_QUOTES_RECEIPT,
    name: 'quote-receipt',
    component: QuoteReceipt,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_DISCOUNT_CODES,
    name: 'sales_discount_codes',
    component: DiscountCodes,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_TRANSACTIONS,
    name: 'sales_transactions',
    component: Transactions,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_CHILD_TRANSACTIONS,
    name: 'sales_transaction_children',
    component: TransactionChildren,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_ORDERS_ORDER,
    name: 'order',
    component: Order,
    meta: {
      requiresAuth: true
    }
  },
  // need to verify this
  {
    path: Route.SALES_ORDERS_ORDER_RECEIPT,
    name: 'order-receipt',
    component: SaleReceipt,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_TRANSACTIONS_RECEIPT,
    name: 'transaction-receipt',
    component: TransactionReceipt,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_ORDERS_RETURN_ORDERS,
    name: 'return-orders',
    component: ReturnOrders,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_ORDERS_NEW_RETURN_ORDER,
    name: 'new-return-order',
    component: NewReturnOrder,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_ORDERS_RETURN_ORDER,
    name: 'return-order',
    component: ReturnOrder,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_ORDERS_RETURN_ORDER_RECEIPT,
    name: 'return-order-receipt',
    component: ReturnReceipt,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_ORDERS_ORDER_EDIT,
    name: 'order-edit',
    component: OrderEdit,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_ORDERS_ORDER_FULFILL,
    name: 'order-fulfill',
    component: OrderFulfill,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_ORDERS_ORDER_PAYMENT,
    name: 'order-payment',
    component: OrderPayment,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_REGISTERS_OPEN_REGISTER,
    name: 'open-register',
    component: OpenRegister,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_REGISTERS_CLOSE_REGISTER,
    name: 'close-register',
    component: CloseRegister,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SALES_REGISTERS_CLOSE_REGISTER_REPORT,
    name: 'register-closing-receipt',
    component: RegisterClosingReport,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY,
    name: 'inventory',
    component: Inventory,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEMS,
    name: 'inventory-items',
    component: Items,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEMS_ITEM_BATCHES,
    name: 'inventory-item-batches',
    component: ItemBatches,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEMS_SIMPLE_ITEM,
    name: 'simple-item',
    component: SimpleItem,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEMS_ITEM_VIEW,
    name: 'item-view',
    component: ItemView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEMS_NEW_SIMPLE_ITEM,
    name: 'new-simple-item',
    component: NewSimpleItem,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEM_CUSTOM_PRICE_TYPES,
    name: 'item-custom-price-types',
    component: CustomPrices,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_TRANSACTIONS,
    name: 'inventory-transactions',
    component: InventoryTransactions,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_PACKS,
    name: 'packs',
    component: Packs,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_PACK,
    name: 'pack',
    component: Pack,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_NEW_PACK,
    name: 'new-pack',
    component: NewPack,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEM_CUSTOM_PRICE_TYPE,
    name: 'custom-price',
    component: CustomPrice,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ATTRIBUTES,
    name: 'attributes',
    component: Attributes,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ATTRIBUTES_ATTRIBUTE,
    name: 'attribute',
    component: Attribute,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEM_NEW_ATTRIBUTE,
    name: 'new-attribute',
    component: NewAttribute,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEM_NEW_CUSTOM_PRICE_TYPE,
    name: 'new-custom-price',
    component: NewCustomPrice,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEM_BRANDS,
    name: 'item-brands',
    component: Brands,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEM_BRANDS_BRAND,
    name: 'brand',
    component: Brand,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEM_BRANDS_NEW_BRAND,
    name: 'new-brand',
    component: NewBrand,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEM_CATEGORIES,
    name: 'categories',
    component: Categories,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEM_CATEGORIES_CATEGORY,
    name: 'category',
    component: Category,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEM_CATEGORIES_NEW_CATEGORY,
    name: 'new-category',
    component: NewCategory,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEM_TAGS,
    name: 'tags',
    component: Tags,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEM_TAGS_TAG,
    name: 'tag',
    component: Tag,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ITEM_TAGS_NEW_TAG,
    name: 'new-tag',
    component: NewTag,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_INVENTORY_RECEIVINGS,
    name: 'inventory-receivings',
    component: InventoryReceivings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_INVENTORY_RECEIVINGS_INVENTORY_RECEIVING,
    name: 'inventory-receiving',
    component: InventoryReceiving,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_INVENTORY_RECEIVINGS_NEW_INVENTORY_RECEIVING,
    name: 'new-inventory-receiving',
    component: NewInventoryReceiving,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_INVENTORY_RECEIVINGS_RECEIPT,
    name: 'inventory-receiving-receipt',
    component: InventoryReceivingReceipt,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_INVENTORY_ADJUSTMENTS,
    name: 'inventory-adjustments',
    component: InventoryAdjustments,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_MISSING_SERIALS,
    name: 'missing-serials',
    component: MissingSerials,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_ADD_MISSING_SERIALS,
    name: 'add-missing-serials',
    component: AddMissingSerials,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_INVENTORY_ADJUSTMENTS_INVENTORY_ADJUSTMENT,
    name: 'inventory-adjustment',
    component: InventoryAdjustment,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_INVENTORY_ADJUSTMENTS_NEW_INVENTORY_ADJUSTMENT,
    name: 'new-inventory-adjustment',
    component: NewInventoryAdjustment,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_INVENTORY_ADJUSTMENTS_BULK_INVENTORY_ADJUSTMENT,
    name: 'bulk-inventory-adjustment',
    component: BulkInventoryAdjustment,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_INVENTORY_TRANSFERS,
    name: 'inventory-transfers',
    component: InventoryTransfers,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_INVENTORY_TRANSFERS_INVENTORY_TRANSFER,
    name: 'inventory-transfer',
    component: InventoryTransfer,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_INVENTORY_TRANSFERS_NEW_INVENTORY_TRANSFER,
    name: 'new-inventory-transfer',
    component: NewInventoryTransfer,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_INVENTORY_TRANSFERS_RECEIVE_INVENTORY_TRANSFER,
    name: 'receive-inventory-transfer',
    component: ReceiveInventoryTransfer,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_PRINT_BARCODE,
    name: 'print-barcode',
    component: PrintBarcode,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: Route.CUSTOMERS,
    name: 'customers',
    component: Customers
  },
  {
    path: Route.CUSTOMERS_BIRTHDAYS,
    name: 'customers-birthdays',
    component: CustomersBirthdays
  },
  {
    path: Route.CUSTOMERS_CUSTOMER,
    name: 'customer',
    component: Customer,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.CUSTOMERS_CUSTOMER_VIEW,
    name: 'customer-view',
    component: CustomerView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.CUSTOMERS_NEW_CUSTOMER,
    name: 'new-customer',
    component: NewCustomer,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.CUSTOMERS_NEW_EXAMINATION,
    name: 'new-examination',
    component: NewExamination,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.APPOINTMENTS,
    name: 'appointments',
    component: Appointments
  },
  {
    path: Route.APPOINTMENTS_APPOINTMENT_VIEW,
    name: 'view-appointment',
    component: AppointmentView
  },
  {
    path: Route.APPOINTMENTS_NEW_APPOINTMENT,
    name: 'new-appointments',
    component: NewAppointment
  },
  {
    path: Route.EXAMINATIONS,
    name: 'examinations',
    component: Examination
  },
  {
    path: Route.EXAMINATIONS_EXAMINATION_VIEW,
    name: 'examination',
    component: ExaminationView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.EXAMINATIONS_ZEISS_CARDS,
    name: 'zeiss-cards',
    component: ZeissCards,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.EXAMINATIONS_ZEISS_CARDS_SETTINGS,
    name: 'zeiss-cards-settings',
    component: ZeissCardSettings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.EXAMINATIONS_ZEISS_CARDS_NEW_CARD,
    name: 'zeiss-cards-new-card',
    component: NewZeissCard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.EXAMINATIONS_ZEISS_CARDS_CARD_EDIT,
    name: 'zeiss-cards-card-edit',
    component: NewZeissCard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.EXAMINATIONS_ZEISS_CARDS_CARD_PRINT,
    name: 'zeiss-cards-card-print',
    component: ZeissCardPrint,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.EXAMINATIONS_NEW_EXAMINATION,
    name: 'new-examination',
    component: NewExamination,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.CUSTOMERS_ACCOUNT_STATEMENT,
    name: 'account-statement',
    component: CustomerAccountStatement,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.CUSTOMERS_NOTES,
    name: 'notes',
    component: Notes,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.CUSTOMERS_NOTES_NEW,
    name: 'new-note',
    component: NewNote,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.CUSTOMERS_NOTES_VIEW,
    name: 'note-view',
    component: NoteView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.CUSTOMERS_NOTES_EDIT,
    name: 'note-edit',
    component: NoteEdit,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: Route.PETS,
    name: 'pets',
    component: Pets,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.PETS_PET_VIEW,
    name: 'pet-view',
    component: PetView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.PETS_PET,
    name: 'pet',
    component: Pet,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.PETS_NEW_PET,
    name: 'new-pet',
    component: NewPet,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: Route.VET_SERVICES,
    name: 'vet-services',
    component: VetServices,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.VET_SERVICES_SERVICE,
    name: 'vet-service',
    component: VetService,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.VET_SERVICES_NEW,
    name: 'new-vet-service',
    component: NewVetService,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: Route.EXAMINATIONS_EXAMINATION_RECEIPT,
    name: 'examination-receipt',
    component: () => Promise.resolve(useNewExaminationPrints() ? ExaminationReceiptV2 : ExaminationReceipt),
    meta: {
      requiresAuth: true
    }
  },

  {
    path: Route.EXAMINATIONS_EXAMINATION_ID_PRINT,
    name: 'examination-id-print',
    component: () => Promise.resolve(useNewExaminationPrints() ? ExaminationIDPrintV2 : ExaminationIDPrint),
    meta: {
      requiresAuth: true
    }
  },

  {
    path: Route.COMPANIES,
    name: 'companies',
    component: Companies
  },
  {
    path: Route.DELIVERIES,
    name: 'deliveries',
    component: Deliveries
  },

  {
    path: Route.DELIVERIES_DELIVERY,
    name: 'delivery',
    component: Delivery,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.DELIVERIES_DELIVERY_VIEW,
    name: 'delivery-view',
    component: DeliveryView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.DELIVERIES_NEW_DELIVERY,
    name: 'new-delivery',
    component: NewDelivery,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.DELIVERIES_ACCOUNT_STATEMENT,
    name: 'delivery-account-statement',
    component: DeliveryAccountStatement,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INSURANCES,
    name: 'insurances',
    component: Insurances
  },

  {
    path: Route.INSURANCES_INSURANCE,
    name: 'insurance',
    component: Insurance,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INSURANCES_INSURANCE_VIEW,
    name: 'insurance-view',
    component: InsuranceView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INSURANCES_NEW_INSURANCE,
    name: 'new-insurance',
    component: NewInsurance,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INSURANCES_ACCOUNT_STATEMENT,
    name: 'insurance-account-statement',
    component: InsuranceAccountStatement,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.VENDORS,
    name: 'vendors',
    component: Vendors
  },

  {
    path: Route.VENDORS_VENDOR,
    name: 'vendor',
    component: Vendor,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.VENDORS_VENDOR_VIEW,
    name: 'vendor-view',
    component: VendorView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.VENDORS_NEW_VENDOR,
    name: 'new-vendor',
    component: NewVendor,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: Route.VENDORS_ACCOUNT_STATEMENT,
    name: 'vendor-account-statement',
    component: VendorAccountStatement,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: Route.HR,
    name: 'hr',
    component: HumanResources,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.HR_ROLES,
    name: 'roles',
    component: Roles,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.HR_ROLES_ROLE,
    name: 'role',
    component: Role,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.HR_ROLES_NEW_ROLE,
    name: 'new-role',
    component: NewRole,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.HR_EMPLOYEES,
    name: 'employees',
    component: Employees,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.HR_EMPLOYEES_EMPLOYEE,
    name: 'employee',
    component: Employee,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.HR_EMPLOYEES_NEW_EMPLOYEE,
    name: 'new-employee',
    component: NewEmployee,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.HR_COMMISSIONS,
    name: 'commissions',
    component: Commissions,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.HR_COMMISSIONS_COMMISSION,
    name: 'commission',
    component: Commission,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.HR_COMMISSIONS_NEW_COMMISSION,
    name: 'new-commission',
    component: NewCommission,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.HR_MONEY_COLLECTOR_COMMISSIONS,
    name: 'money-collector-commissions',
    component: MoneyCollectorCommissions,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.HR_MONEY_COLLECTOR_COMMISSIONS_EDIT,
    name: 'money-collector-commission',
    component: MoneyCollectorCommission,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.HR_MONEY_COLLECTOR_COMMISSIONS_NEW,
    name: 'new-money-collector-commission',
    component: NewMoneyCollectorCommission,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.HR_TASKS,
    name: 'hr-tasks',
    component: Tasks,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.HR_EMPLOYEE_SCHEDULE,
    name: 'employee-schedules',
    component: ViewEmployeeSchedule,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.HR_EMPLOYEE_SCHEDULES_NEW_EMPLOYEE_SCHEDULE,
    name: 'new-employee-schedule',
    component: NewEmployeeSchedule,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: Route.ACCOUNTING,
    name: 'accounting',
    component: Accounting,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_SAFES_BANKS,
    name: 'safes-banks',
    component: SafesBanks,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_SAFES_NEW,
    name: 'new-safe',
    component: NewSafe,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_BANKS_NEW,
    name: 'new-bank',
    component: NewBank,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_ACCOUNTS,
    name: 'accounts',
    component: Accounts,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_ACCOUNTS_VIEW,
    name: 'account-view',
    component: AccountView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_ACCOUNTS_ACCOUNT,
    name: 'account',
    component: Account,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_ACCOUNTS_NEW_ACCOUNT,
    name: 'new-account',
    component: NewAccount,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_ACCOUNTS_NEW_ACCOUNT_TEMPLATE,
    name: 'new-account-template',
    component: NewAccountTemplate,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_ACCOUNTS_LOG,
    name: 'account-log',
    component: AccountLog,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_TRANSACTIONS,
    name: 'transactions',
    component: AccountingTransactions,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_TRANSACTIONS_TRANSACTION,
    name: 'transaction',
    component: Transaction,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_TRANSACTIONS_NEW_TRANSACTION,
    name: 'new-transaction',
    component: NewTransaction,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_CUSTOMERS,
    name: 'accounting-customers',
    component: CustomerInvoices,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_CUSTOMER_INVOICES,
    name: 'customer-invoices',
    component: CustomerInvoicesByCustomer,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_VENDORS,
    name: 'accounting-vendors',
    component: AccountingVendors,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_REGISTERS,
    name: 'accounting-registers',
    component: Registers,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_REGISTERS_REGISTER,
    name: 'accounting-register',
    component: Register,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_HR,
    name: 'accounting-hr',
    component: Hr,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_COMPANY,
    name: 'expenses',
    component: Expenses,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_VENDORS_NEW_BILL,
    name: 'new-bill',
    component: NewBill,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_VENDORS_BILL_VIEW,
    name: 'vendorBill',
    component: VendorBillView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_VENDORS_BILL_PAYMENT,
    name: 'bill-payment',
    component: VendorBillPayment,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_VENDORS_BILL_RECEIPT,
    name: 'vendor-bill-receipt',
    component: VendorBillReceipt,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_REGISTERS_REGISTER_TRANSACTION,
    name: 'register-transaction',
    component: RegisterTransaction,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_HR_NEW_PAY,
    name: 'hr-newpay',
    component: NewPay,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.ACCOUNTING_COMPANY_NEW_EXPENSE,
    name: 'new-expense',
    component: NewExpense,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: Route.REPORTS,
    name: 'reports',
    component: Reports,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_SALES_SALES_BY_CATEGORY,
    name: 'sales-by-category',
    component: SalesByCategory,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_SALES_TOP_SOLD_ITEMS,
    name: 'top-sold-items',
    component: TopSoldItems,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_SALES_SALES_DETAILS,
    name: 'sales-details',
    component: SalesDetails,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_SALES_SALES_SUMMARY  ,
    name: 'sales-summary',
    component: SalesSummary,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_ACCOUNTING_FORMS_OF_PAYMENTS,
    name: 'forms-of-payments',
    component: FormsOfPaymentsReport,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_SALES_TOTAL_RETURNS,
    name: 'total-returns',
    component: TotalReturns,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_SALES_WEEKLY_SALES,
    name: 'weekly-sales',
    component: WeeklySales,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_SALES_MONTHLY_SALES,
    name: 'monthly-sales',
    component: MonthlySales,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_SALES_TOP_REPS,
    name: 'top-reps',
    component: TopReps,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_SALES_SALES_REPS,
    name: 'top-sales-reps',
    component: TopSalesReps,
    meta: {
      requiresAuth: true
    }
  }, 
  {
    path: Route.REPORTS_SALES_ORDERS_STATEMENT,
    name: 'orders-statement-report',
    component: OrdersStatementReport,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_SALES_SALES_BY_VENDOR,
    name: 'sales-by-vendor-report',
    component: SalesByVendor,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_SALES_SALES_BY_ITEM,
    name: 'sales-by-item',
    component: SalesByItem,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_SALES_LEAST_SOLD_ITEMS,
    name: 'least-sold-items',
    component: LeastSoldItems,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_VENDORS_TOP_VENDORS,
    name: 'top-vendors-report',
    component: TopVendors,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_VENDORS_OUTSTANDING_BALANCES,
    name: 'vendors-outstanding-balances-report',
    component: VendorsOutstandingBalances,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_VENDORS_FREQUENT_VENDORS,
    name: 'frequent-vendors',
    component: FrequentVendors,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_EXAMINATIONS_NUMBER_OF_EXAMINATIONS,
    name: 'number-of-examinations',
    component: NumberOfExaminations,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_PETS_VET_SERVICES_BY_PET,
    name: 'vet-services-by-pet-report',
    component: VetServicesByPet,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_PETS_VET_ALL_SERVICES,
    name: 'vet-all-services-report',
    component: VetAllServices,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_INVENTORY_INVENTORY_VALUE,
    name: 'inventory-value',
    component: InventoryValue,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_INVENTORY_INVENTORY_VALUE_DETAILS,
    name: 'inventory-value-details',
    component: InventoryValueDetails,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_SALES_SALES_NEW_REGISTER_CLOSING,
    name: 'new-register-closing',
    component: NewRegisterClosing,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_SALES_SALES_COMPARISON,
    name: 'sales-comparison',
    component: SalesComparison,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_VENDORS_VENDORS_BALANCES,
    name: 'vendors-balances',
    component: VendorsBalances,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_ACCOUNTING_CUSTOMERS_BALANCES,
    name: 'customers-balances',
    component: CustomersBalances,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_SALES_SALES_HEATMAP,
    name: 'sales-heatmap',
    component: SalesHeatmap,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_INVENTORY_QUANTITY,
    name: 'quantity-report',
    component: QuantityReport,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_ACCOUNTING_PROFIT_AND_LOSS,
    name: 'profit-and-loss-report',
    component: ProfitAndLoss,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_ACCOUNTING_REGISTER_CLOSING,
    name: 'register-closing-report',
    component: RegisterClosingReportV2,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_ACCOUNTING_REGISTER_CLOSING_SUMMARY,
    name: 'register-closing-summary',
    component: RegisterClosingSummary,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_ACCOUNTING_CASH_ASSETS,
    name: 'cash-assets-report',
    component: CashAssetsReport,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_ACCOUNTING_EXPENSES,
    name: 'expenses-report',
    component: ExpensesReport,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_ACCOUNTING_PROFIT_BY_ITEM,
    name: 'profit-by-item-report',
    component: ProfitByItem,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_INVENTORY_ITEM,
    name: 'item-report',
    component: ItemReport,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_INVENTORY_BATCH_TRACKER,
    name: 'batch-tracker-report',
    component: BatchTrackerReport,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_INVENTORY_EXPIRABLE_ITEMS_INSIGHT,
    name: 'expirable-items-insight-report',
    component: InventoryExpirableItemsInsight,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.SETTINGS,
    name: 'settings',
    component: Settings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.LICENSE,
    name: 'license',
    component: License,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_HR_TOP_SALARIES,
    name: 'top-salary-report',
    component: EmployeesTopSalary,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_HR_EMPLOYEE_ATTENDANCE,
    name: 'employee-attendance-report',
    component: EmployeesAttendance,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_HR_EMPLOYEE_COMMISSION,
    name: 'employee-commission-report',
    component: EmployeessCommissions,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_HR_MONEY_COLLECTOR_COMMISSION,
    name: 'money-collector-commission-report',
    component: MoneyCollectorCommissionReport,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_CUSTOMERS_OUTSTANDING_BALANCES,
    name: 'customers-outstanding-balances-report',
    component: CustomersOutstandingBalances,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_CUSTOMERS_FREQUENT_CUSTOMERS,
    name: 'frequent-customers-report',
    component: FrequentCustomers,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_CUSTOMERS_TOP_CUSTOMERS,
    name: 'top-customers',
    component: TopCustomers,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_INVENTORY_QUICK_FACTS,
    name: 'inventory-quick-facts',
    component: InventoryQuickFacts,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_INVENTORY_LOW_STOCK,
    name: 'low-stock-inventory',
    component: LowStockInventory,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_INVENTORY_NEGATIVE_STOCK,
    name: 'negative-stock-inventory',
    component: NegativeStockInventory,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.REPORTS_INVENTORY_ALL_ITEMS,
    name: 'all-items-report',
    component: AllItemsReport,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.BACKUPS,
    name: 'backups',
    component: Backups,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_NEW_PURCHASE_ORDER,
    name: 'new-purchase-order',
    component: NewPurchaseOrders,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_PURCHASE_ORDERS,
    name: 'purchase-orders',
    component: PurchaseOrders,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_PURCHASE_ORDER,
    name: 'purchase-order',
    component: PurchaseOrder,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_PURCHASE_ORDERS_PURCHASE_ORDER_RECEIPT,
    name: 'purchase-order-receipt',
    component: PurchaseOrderReceipt,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_PURCHASE_ORDERS_NEW_INVENTORY_RECEIVING,
    name: 'purchase-order-new-inventory-receiving',
    component: NewPurchaseOrderInventoryReceiving,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.INVENTORY_IMPORT_ITEMS,
    name: 'import-items',
    component: ImportItems,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.DEV_TOOLS,
    name: 'dev-tools',
    component: DevTools,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: Route.NOTIFICATIONS,
    name: 'notifications',
    component: NotificationsPage,
    meta: {
      requiresAuth: true
    }
  },
]
